import $ from 'jquery';

$(document).ready(function () {
    let $cal = $('.advSearchCal'),
        $up = $('#advSearchCalUp'),
        $down = $('#advSearchCalDown'),
        pageHeight = $cal.outerHeight();

    $up.on('click', function () {
        if (!$cal.scrollTop()) {
            $up.addClass('disabled');
        }
        $down.removeClass('disabled');
        $cal.animate(
            {
                scrollTop: $cal.scrollTop() - pageHeight,
            },
            200,
        );
    });
    $down.on('click', function () {
        $up.removeClass('disabled');
        $cal.animate(
            {
                scrollTop: $cal.scrollTop() + pageHeight,
            },
            200,
        );
    });
});
